import React from 'react'
import styled from 'styled-components/native'

import { FileUploadProvider } from './provider'
import { FileUploadTitle } from './title'
import { FileUploadError } from './error'
import { FileUploadContent } from './content'

export const FileUploadContainer = styled.View`
  color: rgba(0, 0, 0, 0.5);
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
`

export type FileUploadInputProps = {
  title: string
  errorMessage?: string
  onPress?: () => void
  testId?: string
}

/**
 *
 * FileUploadInput component
 *
 * @param {FileUploadInputProps} props - The props for the FileUploadInput component.
 * @returns {JSX.Element} The rendered FileUploadInput component.

 */
function FileUploadInput({
  title,
  errorMessage,
  onPress,
  testId = 'FILE_UPLOAD_INPUT',
}: FileUploadInputProps) {
  return (
    <FileUploadProvider title={title} errorMessage={errorMessage} onPress={onPress} testId={testId}>
      <FileUploadContainer>
        <FileUploadTitle />
        <FileUploadContent />
        <FileUploadError />
      </FileUploadContainer>
    </FileUploadProvider>
  )
}

export default FileUploadInput
